import Util from "./util/Util";
const rootUrl = Util.checkHttps(process.env.REACT_APP_BE_URL);

var APIUrl = {
  // Authentication
  login: rootUrl + "/auth/login", // POST {username, password}
  logout: rootUrl + "/logout", // GET

  // User
  getUser: rootUrl + "/user", // GET
  updateLang: rootUrl + "/user/lang/", // GET {lang = ["en", "fr"]}
  checkIfUsernameExists: rootUrl + "/user/check/username/", // GET {username}
  checkIfUsernameExistsByGroupId: rootUrl + "/user/check/group/username/", // GET {username}
  checkIfEmailExists: rootUrl + "/user/check/email/", // GET {email}
  updateUser: rootUrl + "/user/update", // POST {updatedField, updatedValue}
  createUser: rootUrl + "/user/create", // POST (admin)
  getAdmin: rootUrl + "/user/getadmin", // GET {}
  deleteAdminNotifs: rootUrl + "/user/deleteadminnotifs",

  // Rgpd
  createRgpd: rootUrl + "/rgpd/create", // POST
  resetRgpd: rootUrl + "/rgpd/reset", // POST
  getRgpd: rootUrl + "/rgpd/", // GET {}

  // Companies
  checkIfCompanyUrlExists: rootUrl + "/company/check/url/", // GET {url}
  checkIfSerialNumberExists: rootUrl + "/company/check/serialNumber/", // GET {serialNumber}
  checkIfDeskVideoExists: rootUrl + "/company/check/video/", // GET {companyId}
  testCompanyCrmSettings: rootUrl + "/company/crmTestEnable",
  checkIfUpdatedEmailExists: rootUrl + "/user/check/updatedemail/", // GET {updatedemail}
  createCompany: rootUrl + "/company/create", // POST
  updateCompany: rootUrl + "/company/update", // POST
  updateCompanyCrm: rootUrl + "/company/updateCrm",
  updateCompanyCrmByField: rootUrl + "/company/updateCrmByField",
  deleteCompanyCrm: rootUrl + "/company/deleteCrm",
  getCompany: rootUrl + "/company", // GET
  blockCompany: rootUrl + "/company/block", // POST
  addDeskVideo: rootUrl + "/company/upload/video/", // {companyId}
  getDeskVideo: rootUrl + "/asset/desk/video/",

  // Groups
  createGroup: rootUrl + "/groups/create", // POST
  updateGroup: rootUrl + "/groups/update", // POST
  getGroups: rootUrl + "/groups", // GET
  blockGroup: rootUrl + "/groups/block", // POST

  // Stats
  getConnections: rootUrl + "/stats/general/connections", // GET

  getPharmaClients: rootUrl + "/stats/pharma/clients",
  getPharmaPatients: rootUrl + "/stats/pharma/patients",
  getPharmaMercurials: rootUrl + "/stats/pharma/mercurials",
  getPharmaInterventions: rootUrl + "/stats/pharma/interventions",
  getPharmaMaintenances: rootUrl + "/stats/pharma/maintenances",
  getPharmaAuditHome: rootUrl + "/stats/pharma/audit/home",
  getPharmaAuditDesk: rootUrl + "/stats/pharma/audit/desk",

  // Product
  getProductsPaginated: rootUrl + "/product/paginated", // GET
  getProductsCount: rootUrl + "/product/count", // GET
  getProductImg: rootUrl + "/product/img/", // GET {keyword}
  getProductDocument: rootUrl + "/product/document/", // GET {documentId}
  isProductKeywordAlreadyExists: rootUrl + "/product/check/", // GET {keyword}
  addProduct: rootUrl + "/product/add/", // POST {data}
  updateProduct: rootUrl + "/product/update", // POST
  deleteProduct: rootUrl + "/product/remove", // POST {_id}
  addProductImage: rootUrl + "/product/img/add/", // POST {productId, files}
  addProductDocument: rootUrl + "/product/document/add/", // POST {productId, files}
  deleteProductDocument: rootUrl + "/product/document/remove", // POST {documentId}

  // Families
  getFamiliesPaginated: rootUrl + "/families/paginated", // GET
  getFamiliesCount: rootUrl + "/families/count", // GET
  getFamilyImg: rootUrl + "/families/img/", // GET {familyId}
  isProductFamilyKeywordAlreadyExists: rootUrl + "/families/check/", // GET {keyword}
  addProductFamily: rootUrl + "/families/add/", // POST {keywords}
  updateProductFamily: rootUrl + "/families/update", // POST
  deleteProductFamily: rootUrl + "/families/remove", // POST {_id}
  addProductFamilyImage: rootUrl + "/families/img/add/", // POST {familyId, files}
};

var sessionJWT = sessionStorage.getItem("jwt");
if (sessionJWT) APIUrl.jwtToken = sessionJWT;

export default APIUrl;
